import { useEffect } from "react";
import LegalPage, { type LegalSection } from "@/components/feature/LegalPage";

const SECTIONS: LegalSection[] = [
  {
    heading: "Acceptance of these terms",
    body: [
      "By creating an account or using Joble, you agree to these Terms of Service. If you are using Joble on behalf of a business, you confirm that you have the authority to bind that business to these terms.",
      "If you do not agree with any part of these terms, please do not use the service.",
    ],
  },
  {
    heading: "The service",
    body: [
      "Joble provides AI Web and Phone Agents plus a Workspace to help you handle customer conversations. We work hard to keep the service available and reliable, but we provide it on an as-is basis and cannot guarantee uninterrupted access.",
      "We may add, change or remove features over time. When a change significantly affects how you use Joble, we will give you reasonable notice.",
    ],
  },
  {
    heading: "Your account",
    body: [
      "You are responsible for keeping your login details secure and for all activity that happens under your account. Please let us know immediately if you suspect any unauthorised use.",
      "You must be at least 18 years old, or the age of legal majority in your region, to use Joble.",
    ],
  },
  {
    heading: "Acceptable use",
    body: [
      "You agree to use Joble lawfully and not to send spam, harass anyone, misrepresent your identity, or use the service to break any applicable law or regulation.",
      "You are responsible for the content your agents share and for making sure you have the rights to any information you connect to Joble.",
    ],
  },
  {
    heading: "Plans and payment",
    body: [
      "Some features require a paid plan. Fees are billed in advance and, unless stated otherwise, are non-refundable. You can cancel at any time and your plan will continue until the end of the current billing period.",
      "We may change our pricing in the future. We will always give you advance notice before a change affects you.",
    ],
  },
  {
    heading: "Intellectual property",
    body: [
      "Joble and its underlying technology belong to us. You keep ownership of your content and the data you bring to the service, and you grant us the licence needed to operate the service on your behalf.",
    ],
  },
  {
    heading: "Limitation of liability",
    body: [
      "To the fullest extent permitted by law, Joble is not liable for indirect, incidental or consequential damages, or for lost profits or revenue, arising from your use of the service.",
      "Our total liability for any claim relating to the service is limited to the amount you paid us in the twelve months before the claim arose.",
    ],
  },
  {
    heading: "Changes to these terms",
    body: [
      "We may update these terms from time to time. We will post the updated version here and, for material changes, notify you by email or in the product. Continuing to use Joble after a change means you accept the new terms.",
    ],
  },
];

export default function TermsPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Terms of Service | Joble";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <LegalPage
      eyebrow="Terms of Service"
      title="The rules of the road"
      updated="Last updated: 6 October 2026"
      intro="These terms set out the agreement between you and Joble when you use our AI Web and Phone Agents and Workspace. We have kept the language as clear as possible so there are no surprises."
      sections={SECTIONS}
    />
  );
}